import { observer } from 'mobx-react-lite';
import { FC, useCallback, useState } from 'react';
import { ROUTES } from '~/routes/routes';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Select, MenuItem } from '@mui/material';
import { DropdownArrow } from '~/views/atoms/svg-icons/dropdown-arrow';
import { IAccountMenu } from '~/views/types';
import { AccountMenuItem } from '~/views/enums';

export const AccountMenu: FC<IAccountMenu> = observer(props => {
    const selectedPage: AccountMenuItem = props.activeItem;
    const navigate = useNavigate();

    const [mobileSelectedPage, setMobileSelectedPage] = useState<AccountMenuItem>(selectedPage);

    const onAccountPageChange = useCallback(
        (event: { target: { value: string } }) => {
            const menuItemValue = event.target.value as AccountMenuItem;
            setMobileSelectedPage(menuItemValue);

            let path: string = ROUTES.PERSONAL_INFO.path;
            switch (menuItemValue) {
                case AccountMenuItem.personalInfo:
                    path = ROUTES.PERSONAL_INFO.path;
                    break;
                case AccountMenuItem.payments:
                    path = ROUTES.ACCOUNT_PAYMENTS.path;
                    break;
                case AccountMenuItem.purchaseHistory:
                    path = ROUTES.PURCHASE_HISTORY.path;
                    break;
                default:
                    path = ROUTES.PERSONAL_INFO.path;
                    break;
            }
            navigate(path);
        },
        [navigate, setMobileSelectedPage],
    );

    const menuItems = [
        {
            title: 'Personal info',
            link: ROUTES.PERSONAL_INFO.path,
            className: selectedPage === AccountMenuItem.personalInfo ? 'account-active' : '',
            imgSrc:
                selectedPage === AccountMenuItem.personalInfo
                    ? '/assets/img/personal-info-active.svg'
                    : '/assets/img/personal-info.svg',
            mobileTitle: 'Personal info',
            mobileValue: AccountMenuItem.personalInfo,
        },
        {
            title: 'Payments',
            link: ROUTES.ACCOUNT_PAYMENTS.path,
            className: selectedPage === AccountMenuItem.payments ? 'account-active' : '',
            imgSrc:
                selectedPage === AccountMenuItem.payments
                    ? '/assets/img/account-payments-active.svg'
                    : '/assets/img/account-payments.svg',
            mobileTitle: 'Payment methods',
            mobileValue: AccountMenuItem.payments,
        },
        {
            title: 'Purchase History',
            link: ROUTES.PURCHASE_HISTORY.path,
            className: selectedPage === AccountMenuItem.purchaseHistory ? 'account-active' : '',
            imgSrc:
                selectedPage === AccountMenuItem.payments
                    ? '/assets/img/purchase-history-active.svg'
                    : '/assets/img/purchase-history.svg',
            mobileTitle: 'Purchase History',
            mobileValue: AccountMenuItem.purchaseHistory,
        },
    ];

    return (
        <div className={'account-menu' + (selectedPage === AccountMenuItem.purchaseHistory ? ' account-menu-ph' : '')}>
            {false && (
                <div className="account-menu-inner">
                    {menuItems.map((item, index) => (
                        <div className="account-menu-item" key={index}>
                            <figure>
                                <img src={item.imgSrc} />
                            </figure>
                            <Link className={item.className} to={item.link}>
                                {item.title}
                            </Link>
                        </div>
                    ))}
                </div>
            )}
            {false && (
                <div className="account-menu-select">
                    <Select
                        className="hr-select"
                        IconComponent={DropdownArrow}
                        value={mobileSelectedPage}
                        onChange={onAccountPageChange}
                    >
                        {menuItems.map((item, index) => (
                            <MenuItem key={index} value={item.mobileValue}>
                                {item.mobileTitle}
                            </MenuItem>
                        ))}
                    </Select>
                </div>
            )}
        </div>
    );
});
